import dayjs from 'dayjs';

/**
 * The price the API invoices when no subscription price is set, in
 * `getSubscriptionPrice` of its pensioners route.
 * @constant
 * @type {number}
 */
export const DEFAULT_SUBSCRIPTION_PRICE = 20;

/**
 * Picks the subscription price in force, as the API does when it invoices a
 * subscription: the unarchived price whose period covers the day, else the
 * one ending last.
 * @function
 *
 * @param {Array<Object>} prices - The subscription prices, sorted by end date,
 * latest first.
 * @param {dayjs.Dayjs} [day=dayjs()] - The day to read the price for.
 * @returns {number} The price in euros, including taxes.
 */
export const currentSubscriptionPrice = (prices = [], day = dayjs()) => {
  const inForce = prices.find(
    ({ application_date, end_date, is_archived }) =>
      !is_archived &&
      application_date &&
      end_date &&
      !dayjs(application_date).isAfter(day.startOf('day')) &&
      dayjs(end_date).isAfter(day.endOf('day'))
  );

  return (inForce || prices[0])?.price || DEFAULT_SUBSCRIPTION_PRICE;
};
